import { Logger } from '@ori/logger';
import { PACKAGE_NAME, TEAM_NAME } from './constants-generated';
export const mainLogger = new Logger(PACKAGE_NAME, {
  teamName: TEAM_NAME
});